


import axios, { AxiosResponse } from 'axios';
import {Response} from '../../interface/IResponse';


import {LoanReportTableData, LoanReportFilterInput, PdfDownloadOutput} from '../../interface/ILoanReport';
import {ApiResponse} from '../../interface/IResponse';






async function listLoanReportDataFunction() : Promise<AxiosResponse<ApiResponse<LoanReportTableData[]>>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + `/LoanReport/getLoanReport`;

        const response: AxiosResponse<ApiResponse<LoanReportTableData[]>> = await axios.get<ApiResponse<LoanReportTableData[]>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}


async function generateHtmlReportFunction() : Promise<AxiosResponse<ApiResponse<PdfDownloadOutput>>>{

    try
    {

        var apiUrl = process.env.REACT_APP_API_URL + `/LoanReport/getHtmlLoanReport`;

        const response: AxiosResponse<ApiResponse<PdfDownloadOutput>> = await axios.get<ApiResponse<PdfDownloadOutput>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

            throw error.response?.data.message;

        }
        else{
            throw error;
        }
    }
}


const loanReportService = {
    listLoanReportData: listLoanReportDataFunction,
    generateHtmlReport: generateHtmlReportFunction
}

export default loanReportService;